module.exports = __webpack_public_path__ + "img/588698.9a6056af.jpg";